import { useSncrNumeracoesDrawerOptional } from "../context/SncrNumeracoesDrawerContext";
import { useSncrGovBrLogin } from "../hooks/useSncrGovBrLogin";
import { SncrConnectButton } from "./SncrConnectButton";

export function SncrHeaderConnect() {
  const { isConnected, loginWithGovBr } = useSncrGovBrLogin();
  const drawer = useSncrNumeracoesDrawerOptional();

  return (
    <SncrConnectButton
      isConnected={isConnected}
      onConnect={loginWithGovBr}
      onConnectedClick={drawer?.openSncrNumeracoes}
    />
  );
}
